module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/main-visual-f2231a57d89a1e77b082d6ee0d7a5d06.jpg";